import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
    faLock,
    faStar,
    faAtomSimple,
    faAngleLeft,
    faAngleDown,
    faArrowLeftFromLine,
    faArrowRightFromLine,
    faArrowRightToLine,
    faArrowLeftToLine,
    faArrowLeftToBracket,
    faArrowUpArrowDown,
    faBars,
    faBarsFilter,
    faBackwardStep,
    faBuilding,
    faBuildings,
    faCalendar,
    faCaretRight,
    faCaretDown,
    faChartSimple,
    faChevronLeft,
    faChevronRight,
    faCircle,
    faCircleArrowRight,
    faCircleArrowLeft,
    faCircleArrowUp,
    faCircleArrowDown,
    faCircleInfo,
    faCirclePlus,
    faCog,
    faConveyorBeltBoxes,
    faCrown,
    faEarthAmericas,
    faEdit,
    faEllipsisH,
    faEllipsisVertical,
    faEnvelope,
    faEye,
    faExclamation,
    faExternalLink,
    faFlag,
    faGlobe,
    faHeadset,
    faHome,
    faMagnifyingGlass,
    faMapMarkerAlt,
    faMicrochip,
    faMoneyBillWave,
    faPaperPlane,
    faPaperclip,
    faPhone,
    faPlus,
    faRankingStar,
    faSackDollar as fasSackDollar,
    faSitemap,
    faSquareArrowUpRight,
    faTableTree,
    faTrashCan,
    faTriangleExclamation,
    faXmark,
    faUser,
    faUserTie,
    faArrowUpRight,
    faArrowUpRightFromSquare,
    faArrowDownRight,
    faArrowRight,
    faArrowRightLong,
    faArrowLeftLong,
    faThList,
    faChartLine,
    faChartLineUp,
    faCheck,
    faListDropdown,
    faListTree,
    faCodeCompare,
    faBooks,
    faDownload,
    faChevronDown,
    faLocationCrosshairs,
    faFileContract,
    faFileArrowDown,
    faPrint,
    faChevronsLeft,
    faTableLayout,
    faTimeline,
    faChartNetwork,
    faMerge,
    faViolin,
    faPuzzlePieceSimple,
    faPuzzle,
    faRotate,
    faChartScatter,
    faScroll,
    faArrowsFromLine,
    faObjectsColumn,
    faSwords,
    faCircleExclamation,
    faThumbTack,
    faTruckContainer,
    faDumbbell,
    faDiagramSuccessor,
    faChartTreeMap,
    faCity,
    faMemo,
    faBoxesStacked,
    faPencil,
    faBullseye,
    faGrid2,
    faSparkles,
    faGear,
    faCircleMinus,
    faPeopleGroup,
    faBook,
    faLightbulbOn,
    faSquareList,
    faGavel,
    faSeedling,
    faHourglassEnd,
    faShuffle,
    faCubesStacked,
} from '@fortawesome/pro-solid-svg-icons'
import { faStore as fadStore } from '@fortawesome/pro-duotone-svg-icons'
import {
    faDiagramSubtask,
    faFileLines,
    faSackDollar,
    faSitemap as farSitemap,
    faCircleQuestion,
} from '@fortawesome/pro-regular-svg-icons'
import { faCircleExclamation as falCircleExclamation } from '@fortawesome/pro-light-svg-icons'

library.add(
    faPeopleGroup,
    faStar,
    faCircleMinus,
    faGear,
    faSparkles,
    faTimeline,
    faGrid2,
    faBullseye,
    faPencil,
    faBoxesStacked,
    faMemo,
    faCity,
    faChartTreeMap,
    faDumbbell,
    faDiagramSuccessor,
    faThumbTack,
    faSwords,
    faObjectsColumn,
    faArrowsFromLine,
    faRotate,
    faPuzzlePieceSimple,
    faPuzzle,
    faViolin,
    faMerge,
    faChartNetwork,
    faTableLayout,
    faChevronsLeft,
    faPrint,
    faAtomSimple,
    faAngleLeft,
    faAngleDown,
    faArrowDownRight,
    faArrowLeftToBracket,
    faArrowUpArrowDown,
    faBars,
    faBarsFilter,
    faArrowLeftFromLine,
    faArrowRightFromLine,
    faArrowRightToLine,
    faArrowLeftToLine,
    faArrowRight,
    faArrowRightLong,
    faArrowLeftLong,
    faArrowUpRight,
    faArrowUpRightFromSquare,
    faBackwardStep,
    faBooks,
    faBuilding,
    faBuildings,
    faCalendar,
    faChartSimple,
    faCaretRight,
    faCaretDown,
    faChartLine,
    faChartLineUp,
    faCheck,
    faChevronDown,
    faChevronRight,
    faChevronLeft,
    faCircle,
    faCircleArrowRight,
    faCircleArrowLeft,
    faCircleArrowUp,
    faCircleArrowDown,
    faCircleInfo,
    faCirclePlus,
    faCircleQuestion,
    faCodeCompare,
    faCog,
    faConveyorBeltBoxes,
    faCrown,
    faDiagramSubtask,
    faDownload,
    fadStore,
    faEarthAmericas,
    faEdit,
    faEllipsisH,
    faEllipsisVertical,
    faEnvelope,
    faEye,
    faExclamation,
    faExternalLink,
    faFileLines,
    faFileArrowDown,
    faFlag,
    faLock,
    faGlobe,
    faHeadset,
    faHome,
    faListDropdown,
    faListTree,
    faLocationCrosshairs,
    faMagnifyingGlass,
    faMapMarkerAlt,
    faMicrochip,
    faMoneyBillWave,
    faPaperPlane,
    faPaperclip,
    faPhone,
    faPlus,
    faRankingStar,
    farSitemap,
    faSackDollar,
    faSitemap,
    faSquareArrowUpRight,
    fasSackDollar,
    faTableTree,
    faThList,
    faTrashCan,
    faTriangleExclamation,
    faTruckContainer,
    faUser,
    faUserTie,
    faXmark,
    faFileContract,
    faChartScatter,
    faScroll,
    falCircleExclamation,
    faCircleExclamation,
    faBook,
    faLightbulbOn,
    faSquareList,
    faGavel,
    faSeedling,
    faHourglassEnd,
    faShuffle,
    faCubesStacked
)

export default FontAwesomeIcon
